import { FunctionComponent } from 'react'
import styles from './title.module.scss'

interface TitleProps {
    text?: string
    className?: string
}

const Title: FunctionComponent<TitleProps> = ({ text, className }: TitleProps) => {
    return <h2 className={`${styles.titleStyle} ${className}`}>{text}</h2>
}

export default Title
